import { render, staticRenderFns } from "./Magacin.vue?vue&type=template&id=4541bb66&"
import script from "./Magacin.vue?vue&type=script&lang=js&"
export * from "./Magacin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports